import React from 'react'
import ContactHero from '../../components/ContactComponets/ContactHero'
import ContactInfo from '../../components/ContactComponets/ContactInfo'
import OfficeLocations from '../../components/ContactComponets/OfficeLocations'
import ContactForm from '../../components/ContactComponets/ContactForm'
import SocialLinks from '../../components/ContactComponets/SocialLinks'

const ContactPage = () => {
  return (
    <div className='ContactPage my-10 py-10 sm:p-10'>
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <OfficeLocations />
      <SocialLinks />
    </div>
  )
}

export default ContactPage
